<template>
  <section class="placeholder-page">
    <svg class="placeholder-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z" /><path d="M8 9h8M8 12h5" /></svg>
    <p class="home-kicker">커뮤니티</p>
    <h1>커뮤니티</h1>
    <p>커뮤니티 기능을 준비하고 있습니다. 열리면 이곳에서 알려 드릴게요.</p>
  </section>
</template>